<script>
  import {mapGetters} from 'vuex';
  import {Bar} from "vue-chartjs";
  import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
  import ChartMixin from '@/mixins/charts';

  export default {
    extends: Bar,
    props: ['chartdata', 'options', 'width', 'height', 'datalabels'],
    mixins: [ChartMixin],
    computed: {
      ...mapGetters({
        chartColors: 'helper/getChartColors'
      }),
    },
    mounted() {
      this.customRenderChart(true)
    },
    methods: {
      customRenderChart: function(enableAnimations) {
        this.chartdata.datasets.forEach((dataset, i) => {
          dataset.backgroundColor = this.chartColors[i % this.chartColors.length ]
        });

        if(!this.options.hasOwnProperty('scales')) {
          this.options.scales = {};
        }

        if(!this.options.scales.hasOwnProperty('yAxes')) {
          this.options.scales.yAxes = [{}];
        }

        if(!this.options.scales.hasOwnProperty('xAxes')) {
          this.options.scales.xAxes = [{}];
        }


        this.options.scales.yAxes.forEach(item => {
          if (item.hasOwnProperty('ticks')) {
            item.ticks.beginAtZero = true
          } else {
            item.ticks = { beginAtZero: true }
          }
        })

        this.options.scales.xAxes.forEach(item => {
          if (item.hasOwnProperty('ticks')) {
            item.ticks.beginAtZero = true
          } else {
            item.ticks = { beginAtZero: true }
          }
        })

        this.options.tooltips = {};
        this.options.tooltips.callbacks = {
          label: function(t, d) {
            let xLabel = d.datasets[t.datasetIndex].label;
            let field = d.datasets[t.datasetIndex].field;

            if(field.includes('currency')) {
              return xLabel + ': $ ' + t.yLabel.toFixed(2);
            }

            return xLabel + ': ' + t.yLabel;
          }
        }

        this.options.animation = enableAnimations;

        this.options.plugins = {
          datalabels: {
            color: this.datalabels ? '#000000' : 'transparent',
            align: 'top',
            anchor: 'end',
          }
        }

        this.addPlugin(ChartJsPluginDataLabels);

        // this sets white background when printing chart
        this.addBackgroundPlugin(this);

        this.renderChart(this.chartdata, this.options)
      }
    },
    watch: {
      datalabels: function() {
        this.customRenderChart();
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// BarChart.vue?bc569ae0